﻿"use strict";

import { ioDatatypes } from "../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter } from "../blib.js";

import * as blib from "../../../blib/index.js";
import * as xlib from "../../../xlib/index.js";

//import xlib = refs.xlib;



import * as pjscGlobalConfig from "../../../pjsc-config/client-config.js"; export { pjscGlobalConfig };


//import __ = xlib.lolo;



/** R5: the server-validated publishable key for this environment (test mode outside gcpprod), from `/client-env.js` */
export var STRIPE_PUBLIC_KEY: string = ( window as any ).__PJSC_CLIENT_ENV.stripePublishableKey;
if ( typeof STRIPE_PUBLIC_KEY !== "string" || STRIPE_PUBLIC_KEY.length === 0 ) {
	throw new Error( "window.__PJSC_CLIENT_ENV.stripePublishableKey missing: the page must load /client-env.js before its bundle" );
}

/** this environment's public reCAPTCHA site key (server `PJSC_RECAPTCHA_SITE_KEY`), from `/client-env.js` */
export var RECAPTCHA_SITE_KEY: string = ( window as any ).__PJSC_CLIENT_ENV.recaptchaSiteKey;
if ( typeof RECAPTCHA_SITE_KEY !== "string" || RECAPTCHA_SITE_KEY.length === 0 ) {
	throw new Error( "window.__PJSC_CLIENT_ENV.recaptchaSiteKey missing: the page must load /client-env.js before its bundle" );
}

///**
// * if true, force the client to redirect to https
// */
//if (forceHttps === true) {
//	if (window.location.protocol != "https:" ) {		
//		window.location.href = "https:" + window.location.href.substring(window.location.protocol.length);
//	}
//}